import _regeneratorRuntime from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
// import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger';
export default {
  components: {
    // Breadcrumb,
    Hamburger: Hamburger
  },
  computed: _objectSpread({}, mapGetters(['name', 'sidebar', 'avatar'])),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
              this.$router.push("/login?redirect=".concat(this.$route.fullPath));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }
};